import HttpClient from './http-clients/portaljad'

const baseUrl = 'usuarios/firebaseUid'

export default class UsuariosService {
  static async findByUid(firebaseUid, senha) {
    try {
      if (!firebaseUid) {
        return undefined
      }
      const { data } = await HttpClient.post(baseUrl, { firebaseUid, senha })
      return data.body
    } catch (error) {
      throw error.response.data
    }
  }

  static async findById(id) {
    try {
      const { data } = await HttpClient.get(['usuarios', id].join('/'))
      return data
    } catch (error) {
      throw error.response.data
    }
  }

  static async authTokenTemporario(dados, token) {
    try {
      const { data } = await HttpClient.put(['usuarios', 'auth', 'custom-token', token].join('/'), dados)
      return data
    } catch (error) {
      throw error.response.data
    }
  }
}